import '@tiger/bs-modal/modal.css'; // 还有一个css文件，主要是隐藏空的标题栏

export * from '@tiger/bs-modal';
export { default } from '@tiger/bs-modal'; // 不能省略，貌似TS的declaration对于 export * 会漏掉default？
